import { useState } from "react";
import { Link } from "react-router-dom";
import { formatCount, getCategoryName, getHotVideos, getLatestVideos } from "@/utils/video";

type FeedTab = "hot" | "latest";

export default function HomeFeed() {
  const [tab, setTab] = useState<FeedTab>("hot");
  const list = tab === "hot" ? getHotVideos(6) : getLatestVideos(6);

  return (
    <aside className="flex h-full flex-col overflow-hidden rounded-lg border border-background-200/90 bg-white">
      <div className="flex items-center justify-between gap-2 border-b border-background-200/80 px-4 py-3">
        <div>
          <h2 className="font-heading text-sm font-semibold text-foreground-950">内容速览</h2>
          <p className="mt-0.5 font-label text-[10px] uppercase tracking-[0.16em] text-foreground-400">
            {tab === "hot" ? "Most Viewed" : "Just Added"}
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-1 rounded-full bg-background-100 p-1">
          <button
            type="button"
            onClick={() => setTab("hot")}
            className={`cursor-pointer whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-medium transition-colors ${
              tab === "hot"
                ? "bg-primary-500 text-background-50"
                : "text-foreground-600 hover:text-foreground-900"
            }`}
          >
            最热
          </button>
          <button
            type="button"
            onClick={() => setTab("latest")}
            className={`cursor-pointer whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-medium transition-colors ${
              tab === "latest"
                ? "bg-primary-500 text-background-50"
                : "text-foreground-600 hover:text-foreground-900"
            }`}
          >
            最新
          </button>
        </div>
      </div>

      <ul className="flex-1 divide-y divide-background-100">
        {list.map((video, index) => (
          <li key={video.id}>
            <Link
              to={`/detail/${video.id}`}
              className="focus-ring group flex items-center gap-3 px-4 py-2.5 transition-colors hover:bg-background-50"
            >
              <span
                className={`flex w-4 shrink-0 justify-center font-label text-[11px] font-semibold ${
                  index < 3 && tab === "hot" ? "text-accent-600" : "text-foreground-400"
                }`}
              >
                {index + 1}
              </span>
              <span className="relative h-11 w-[68px] shrink-0 overflow-hidden rounded bg-background-200">
                <img
                  src={video.cover}
                  alt={`${video.title} 封面缩略图`}
                  title={`${video.title} - 内容速览`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute bottom-0.5 right-0.5 rounded bg-primary-950/80 px-1 font-label text-[9px] text-background-50">
                  {video.duration}
                </span>
              </span>
              <span className="min-w-0 flex-1">
                <span className="line-clamp-1 text-xs font-medium text-foreground-900 transition-colors group-hover:text-secondary-600">
                  {video.title}
                </span>
                <span className="mt-1 flex items-center gap-1.5 font-label text-[10px] text-foreground-500">
                  <span>{getCategoryName(video.category)}</span>
                  <span className="text-background-300">·</span>
                  <span className="inline-flex items-center gap-0.5">
                    <i className="ri-eye-line text-[10px]" aria-hidden="true" />
                    {formatCount(video.views)}
                  </span>
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>

      <Link
        to="/category/all"
        className="focus-ring group flex items-center justify-center gap-1 border-t border-background-200/80 px-4 py-2.5 text-[11px] font-medium text-foreground-600 transition-colors hover:bg-background-50 hover:text-secondary-700"
      >
        浏览全部视频
        <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
      </Link>
    </aside>
  );
}